// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1966":"f1fdc056e0846f2b","3899":"3db29ea2a33bff30"}[chunkId] + ".js";
};